"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Tabs = /** @class */ (function (_super) {
    __extends(Tabs, _super);
    function Tabs(props) {
        var _this = _super.call(this, props) || this;
        _this.onMenuClick = function (event) {
            var id = event.currentTarget.getAttribute("data-id");
            _this.setState({
                active: id ? parseInt(id, 10) : undefined,
            });
        };
        _this.state = {
            active: 1,
        };
        return _this;
    }
    Tabs.prototype.render = function () {
        var _this = this;
        var tabs = this.props.tabs;
        var active = this.state.active;
        var menu = tabs.map(function (item, key) {
            var itemClassName = classnames_1.default("emankit__tabs__menu__item", {
                "emankit__tabs__menu__item--active": _this.state.active === key,
            });
            return (react_1.default.createElement("li", { className: itemClassName, onClick: _this.onMenuClick, "data-id": key, key: key },
                react_1.default.createElement("span", null, item.name)));
        });
        var activeContent = active && active < tabs.length ? tabs[active].children : tabs.length ? tabs[0].children : null;
        return (react_1.default.createElement("div", { className: "emankit__tabs" },
            react_1.default.createElement("ul", { className: "emankit__tabs__menu" }, menu),
            react_1.default.createElement("div", { className: "emankit__tabs__content" }, activeContent)));
    };
    return Tabs;
}(react_1.default.Component));
exports.default = Tabs;
//# sourceMappingURL=index.js.map